import React from "react";
import {
  SiTypescript,
  SiJavascript,
  SiPython,
  SiSolidity,
  SiReact,
  SiNextdotjs,
  SiTailwindcss,
  SiRedux,
  SiSocketdotio,
  SiHtml5,
  SiCss3,
  SiNodedotjs,
  SiExpress,
  SiFastapi,
  SiPrisma,
  SiPostgresql,
  SiMysql,
  SiMongodb,
  SiFirebase,
  SiDocker,
  SiGit,
  SiGithub,
  SiVercel,
  SiFigma,
  SiAmazonwebservices,
  SiEthereum,
  SiChainlink,
  SiLangchain,
  SiOpenai,
  SiRedis,
  SiIpfs,
} from "react-icons/si";
import { TbSettings, TbCode, TbServer, TbDatabase, TbCloud, TbHexagon, TbBrain } from "react-icons/tb";

const skillCategories = [
  {
    title: "AI & GenAI",
    icon: <TbBrain className="text-emerald-400" />,
    skills: [
      { name: "LangChain", icon: <SiLangchain className="text-emerald-400" /> },
      { name: "RAG Architecture", icon: <TbBrain className="text-violet-400" /> },
      { name: "OpenAI API", icon: <SiOpenai className="text-[#10a37f]" /> },
    ],
  },
  {
    title: "Languages",
    icon: <TbCode className="text-violet-400" />,
    skills: [
      { name: "TypeScript", icon: <SiTypescript className="text-[#3178c6]" /> },
      { name: "JavaScript", icon: <SiJavascript className="text-[#f7df1e]" /> },
      { name: "Python", icon: <SiPython className="text-[#3776ab]" /> },
      { name: "Solidity", icon: <SiSolidity className="text-[#8c8c8c]" /> },
    ],
  },
  {
    title: "Frontend",
    icon: <TbSettings className="text-indigo-400" />,
    skills: [
      { name: "React.js", icon: <SiReact className="text-[#61dafb]" /> },
      { name: "Next.js", icon: <SiNextdotjs className="text-white" /> },
      { name: "Tailwind CSS", icon: <SiTailwindcss className="text-[#06b6d4]" /> },
      { name: "Redux", icon: <SiRedux className="text-[#764abc]" /> },
      { name: "Socket.io", icon: <SiSocketdotio className="text-white" /> },
      { name: "HTML5", icon: <SiHtml5 className="text-[#e34f26]" /> },
      { name: "CSS3", icon: <SiCss3 className="text-[#1572b6]" /> },
    ],
  },
  {
    title: "Backend",
    icon: <TbServer className="text-cyan-400" />,
    skills: [
      { name: "Node.js", icon: <SiNodedotjs className="text-[#339933]" /> },
      { name: "Express.js", icon: <SiExpress className="text-white" /> },
      { name: "FastAPI", icon: <SiFastapi className="text-[#009688]" /> },
    ],
  },
  {
    title: "Databases & Storage",
    icon: <TbDatabase className="text-emerald-400" />,
    skills: [
      { name: "PostgreSQL", icon: <SiPostgresql className="text-[#4169e1]" /> },
      { name: "MongoDB", icon: <SiMongodb className="text-[#47a248]" /> },
      { name: "Redis", icon: <SiRedis className="text-[#dc382d]" /> },
      { name: "Prisma ORM", icon: <SiPrisma className="text-white" /> },
      { name: "MySQL", icon: <SiMysql className="text-[#00758f]" /> },
      { name: "Firebase", icon: <SiFirebase className="text-[#ffca28]" /> },
    ],
  },
  {
    title: "DevOps & Tools",
    icon: <TbCloud className="text-amber-400" />,
    skills: [
      { name: "Docker", icon: <SiDocker className="text-[#2496ed]" /> },
      { name: "Git", icon: <SiGit className="text-[#f05032]" /> },
      { name: "GitHub", icon: <SiGithub className="text-white" /> },
      { name: "Vercel", icon: <SiVercel className="text-white" /> },
      { name: "AWS", icon: <SiAmazonwebservices className="text-[#ff9900]" /> },
      { name: "Figma", icon: <SiFigma className="text-[#f24e1e]" /> },
    ],
  },
  {
    title: "Blockchain / Web3",
    icon: <TbHexagon className="text-pink-400" />,
    skills: [
      { name: "Solidity", icon: <SiSolidity className="text-[#8c8c8c]" /> },
      { name: "Ethers.js", icon: <SiEthereum className="text-[#627eea]" /> },
      { name: "Hardhat", icon: <SiEthereum className="text-[#f4ea16]" /> },
      { name: "IPFS", icon: <SiIpfs className="text-[#65c2cb]" /> },
      { name: "Chainlink", icon: <SiChainlink className="text-[#375bd2]" /> },
    ],
  },
];

const SkillCard = ({ name, icon }) => (
  <div className="flex items-center gap-2.5 px-3 py-2 rounded-xl bg-zinc-900/30 border border-zinc-800/65 hover:border-zinc-700/50 hover:bg-zinc-800/40 hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
    <div className="text-lg transition-transform duration-300 group-hover:scale-110 flex items-center justify-center">
      {icon}
    </div>
    <span className="text-xs font-medium text-zinc-300 group-hover:text-white transition-colors font-sans">
      {name}
    </span>
  </div>
);

const SkillsGrid = () => (
  <div className="space-y-6">
    {skillCategories.map((category, idx) => (
      <div key={idx} className="space-y-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-zinc-200 font-display">
          {category.icon}
          <span>{category.title}</span>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2.5">
          {category.skills.map((skill, index) => (
            <SkillCard key={index} name={skill.name} icon={skill.icon} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SkillsGrid;
